import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DOILink',
    props: {
        doi: null
    },
    setup(__props) {
        const props = __props;
        library.add(faLink);
        const doiLink = computed(() => `https://doi.org/${props.doi}`);
        return { __sfc: true, props, doiLink, faLink, FontAwesomeIcon, BBadge };
    }
});
